<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 have-finance">
  <form [formGroup]="bookingForm">
    <div class="pt-3 pb-3">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3 class="sub-title text-uppercase mb-3">Personal Details</h3>
        </div>
        <div [ngClass]="{ 'col-12': bookingForm.get('pan_type')?.value === 'Individual' }">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" >
            <label class="form-label mend">Account Type</label>
            <div class="d-flex gap-5 mt-1">
              <div *ngFor="let pan of panTypeOptions let i = index" class="accountType"  [ngClass]="((isAdhaarVerified && isPanVerified) && bookingForm.get('pan_type')?.value === 'Individual') || (isPanVerified && bookingForm.get('pan_type')?.value != 'Individual') ? 'disabled' : ''"> 
                <!-- [ngClass]="(isAdhaarVerified && isPanVerified) ? 'disabled' : ''" -->
                <!-- [ngClass]="(isAdhaarVerified && isPanVerified) ? 'disabled' : ''" -->
                <input
               
                class="accountTypeInput"
                  type="radio"
                  name="pan_type"
                [value]="pan.value"
                  (change)="updateFirstNameValidation($event.target.value)"
                  formControlName="pan_type"
                  [id]="'panType' + i"
  
                />
                <label class="ms-2" [for]="'panType' + i">{{ pan.label }}</label>
              </div>
            </div>
            <div
              *ngIf="bookingForm.get('pan_type').invalid && (bookingForm.get('pan_type').dirty || bookingForm.get('pan_type').touched || isSubmitForm)"
              class="mt-3 alert-danger">
              <div class="error-message" *ngIf="bookingForm.get('pan_type').errors?.['required']">
                <b> &nbsp; Account type is required</b>
              </div>
              <div class="error-message" *ngIf="bookingForm.get('pan_type').errors?.['pattern']">
                <b> &nbsp; Account type is invalid</b>
              </div>
            <!-- <div class="error-message"
            *ngIf="(f['pan_type'].touched || f['pan_type'].dirty || submitted) && f['pan_type'].errors">
            <div *ngIf="f['pan_type'].errors?.['required']"><b>Pan Type is required</b></div>-->
          </div>
          </div>
        </div>
          <div
          class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4"
          *ngIf="bookingForm.get('pan_type')?.value === 'Company'"
        >
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Company Name</label>
          <input
            formControlName="full_name"
            type="text"
            class="form-control h-48"
            placeholder="Ex. XYZ Pvt"
            (input)="validateCompanyName($event)"
            (blur)="checkCompanyNameError()"
            maxlength="50"
            [ngClass]="(isPanVerified) ? 'disabled' : ''"
           
          />
          <div *ngIf="companyNameError" class="error-message alert-danger">
            <b>Company Name cannot contain &lt;, &gt;, &#123;, &#125;, &#124;, &#126;, &#94;, &#42;</b> Please input correct details.
          </div>
          <div class="error-message" *ngIf="hasRequiredError('full_name')">
            <b> &nbsp; Company Name is Required</b>
          </div>
          <div
            class="error-message"
            *ngIf="hasError('full_name', 'invalidCompanyName')"
          >
            <b
              >Company Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126;
              &#94; &#42;</b
            >
          </div>
        </div>
        </div>
          <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingForm.get('pan_type')?.value === 'Individual'">
            <label class="form-label mend">First Name</label>
            <input type="text" [attr.disabled]="typeOfBooking ? '' : null"
              (keydown)="notAllowSpace($event)" maxlength="45" formControlName="first_name" name="first_name" class="form-control h-48"
              placeholder="Ex. Pratik"
              [ngClass]="{
                'is-invalid': bookingForm.get('first_name').invalid && (bookingForm.get('first_name').dirty || bookingForm.get('first_name').touched || isSubmitForm),
                'disabled': isAdhaarVerified && isPanVerified
              }" 
             (input)="onInput($event)"
             (input)="validateName($event, 'first_name')"
             (blur)="checkNameError('first_name')"
              />
            <div
              *ngIf="bookingForm.get('first_name').invalid && (bookingForm.get('first_name').dirty || bookingForm.get('first_name').touched || isSubmitForm)"
              class="mt-3 alert-danger">
              <div *ngIf="nameErrors.first_name" class="error-message alert-danger">
                <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>
              </div>
              <div class="error-message" *ngIf="bookingForm.get('first_name').errors?.['required']">
                <b> &nbsp; First name is required</b>
              </div>
             
            </div>
            
            <div class="error-message" *ngIf="hasError('first_name', 'invalidIndividualName')">
              <b>First Name cannot contain special characters </b>
            </div>
              <div class="error-message" *ngIf="hasError('first_name', 'invalidCompanyName')">
              <b>First Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
            </div>
            
          </div> -->
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingForm.get('pan_type')?.value === 'Individual'">
            <label class="form-label">First Name</label>
            <input type="text" [attr.disabled]="typeOfBooking ? '' : null"
              (keydown)="notAllowSpace($event)" maxlength="45"  (blur)="checkNameError('first_name')"
              formControlName="first_name" class="form-control h-48" placeholder="Ex. Pratik"
              [ngClass]="{
                'is-invalid': bookingForm.get('first_name').invalid && (bookingForm.get('first_name').dirty || bookingForm.get('first_name').touched || isSubmitForm),
                'disabled': isAdhaarVerified && isPanVerified
              }"  (input)="onInput($event)"
             (input)="validateName($event, 'first_name')"
             [ngClass]="(isAdhaarVerified && isPanVerified) ? 'disabled' : ''"
               />
            <div
              *ngIf="bookingForm.get('first_name').invalid && (bookingForm.get('first_name').dirty || bookingForm.get('first_name').touched || isSubmitForm)"
              class="mt-3 alert-danger">
              <!-- <div class="error-message" *ngIf="bookingForm.get('first_name').errors?.['required']">
                <b> &nbsp; *Required</b>
              </div> -->
              <!-- <div class="error-message" *ngIf="bookingForm.get('first_name').errors?.['pattern']">
                <b> &nbsp; *Invalid</b>
              </div> -->
              <div class="error-message" *ngIf="bookingForm.get('first_name').errors?.['required']">
                <b> &nbsp; First name is required</b>
              </div>
            </div>
            <div *ngIf="nameErrors.first_name" class="error-message alert-danger">
              <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>
  
            </div>
            <div class="error-message" *ngIf="hasError('first_name', 'invalidIndividualName')">
              <b>First Name cannot contain special characters </b>
            </div>
              <div class="error-message" *ngIf="hasError('first_name', 'invalidCompanyName')">
              <b>First Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingForm.get('pan_type')?.value === 'Individual'">
            <label class="form-label">Last Name</label>
            <input type="text" [attr.disabled]="typeOfBooking ? '' : null"
              (keydown)="notAllowSpace($event)" maxlength="45"  (blur)="checkNameError('last_name')"
              formControlName="last_name" class="form-control h-48" placeholder="Ex. Maurya" (input)="onInput($event)"
             (input)="validateName($event, 'last_name')"
             [ngClass]="(isAdhaarVerified && isPanVerified) ? 'disabled' : ''"
               />
            <div
              *ngIf="bookingForm.get('last_name').invalid && (bookingForm.get('last_name').dirty || bookingForm.get('last_name').touched || isSubmitForm)"
              class="mt-3 alert-danger">
              <!-- <div class="error-message" *ngIf="bookingForm.get('last_name').errors?.['required']">
                <b> &nbsp; *Required</b>
              </div> -->
              <!-- <div class="error-message" *ngIf="bookingForm.get('last_name').errors?.['pattern']">
                <b> &nbsp; *Invalid</b>
              </div> -->
              
            </div>
  
            <div *ngIf="nameErrors.last_name" class="error-message alert-danger">
              <b>Last Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>
  
            </div>
            <div class="error-message" *ngIf="hasError('last_name', 'invalidIndividualName')">
              <b>Last Name cannot contain special characters </b>
            </div>
              <div class="error-message" *ngIf="hasError('last_name', 'invalidCompanyName')">
              <b>Last Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
            </div>
          </div>
        <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label">Email</label>
          <input type="text" class="form-control h-48" id="uEmail" placeholder="Ex. xyz@gmail.com"
            formControlName="email_id" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
            [attr.disabled]="typeOfBooking ? '' : null" (keydown)="notAllowSpace($event)" maxlength="60" />
          <div *ngIf="bookingForm.get('email_id').invalid && (bookingForm.get('email_id').dirty ||
            bookingForm.get('email_id').touched || isSubmitForm)" class=" alert-danger">

            <div class="error-message" *ngIf="bookingForm.get('email_id').errors?.['pattern']">
              <b> &nbsp; *Invalid</b>
            </div>
          </div>
        </div> -->
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">State</label>
          <select class="form-select h-48" formControlName="state" (change)="getDistrictList()"
            [attr.disabled]="typeOfBooking ? '' : null"
            [ngClass]="{
              'is-invalid': bookingForm.get('state').invalid && (bookingForm.get('state').dirty || bookingForm.get('first_name').touched || isSubmitForm)
            }">
            <option value="" disabled selected>Select your state</option>
            <option *ngFor="let state of stateList" value="{{ state.code }}">
              {{ state.name | titlecase }}
            </option>
          </select>
          <div
            *ngIf="bookingForm.get('state').invalid && (bookingForm.get('state').dirty || bookingForm.get('state').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('state').errors?.['required']">
              <b>   State is required</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('state').errors?.['pattern']">
              <b>   State is invalid</b>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">District</label>
          <select class="form-select h-48" formControlName="district" (change)="getDealerList()"
            [attr.disabled]="typeOfBooking ? '' : null"
            [ngClass]="{
              'is-invalid': bookingForm.get('district').invalid && (bookingForm.get('district').dirty || bookingForm.get('district').touched || isSubmitForm)
            }">
            <option value="" selected disabled>Select your district</option>
            <option *ngFor="let district of districtList" value="{{ district }}">
              {{ district | titlecase }}
            </option>
          </select>
          <div
            *ngIf="bookingForm.get('district').invalid && (bookingForm.get('district').dirty || bookingForm.get('district').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('district').errors?.['required']">
              <b>  District is required</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('district').errors?.['pattern']">
              <b>   District is invalid</b>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-start align-items-center mb-3 gap-3 mt-3">
          <h3 class="sub-title text-uppercase mb-3">E-KYC </h3>
          <div
          class="whatsapp-button "
          data-bs-toggle="modal"
          [attr.data-bs-target]="'#cancelpopUp'"
          (click)="connectWebsocket()"
          title="Submit your KYC details securely via the link shared on WhatsApp by Tata Motors FleetVerse"
          *ngIf="iswhtAppVisible"
        >
        <div class="left-section mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
            <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"></path>
            </svg>
            <a href="javascript:void(0)" class="kyc-link">Submit KYC</a>
            <i
          class="ms-2 fas fa-info-circle text-muted"
          title="Submit your KYC securely via WhatsApp link shared by Tata Motors FleetVerse"
          style="cursor: pointer;"
        ></i>
        </div>
        </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingForm.get('pan_type')?.value === 'Individual'">
          <label class="form-label"  [ngClass]="isVasAvailable ? 'mend' : ''">Aadhaar Card</label>
          <input type="text" class="form-control h-48"
          [readonly]="(isAdhaarVerified && isAdhaarNoAvailable && this.isAdhaarNoAvailable != ' ')"
            [ngClass]="(isAdhaarVerified && isAdhaarNoAvailable && this.isAdhaarNoAvailable != ' ') ? 'disabled' : ''"
            formControlName="aadhar" name="aadhar" placeholder="XXXX-XXXX-XXXX" maxlength="12" (keypress)="onlyNumberKey($event)" />
          <div class="error-message" *ngIf="hasRequiredError('aadhar')">*Required</div>
          <div class="error-message" *ngIf="hasPatternError('aadhar') ">
            *Invalid Aadhaar Card No
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label " [ngClass]="isVasAvailable ? 'mend' : ''">Pan Card Number</label>
          <input maxlength="10" formControlName="panNo" name="panNo" type="text" class="form-control h-48"
          [readonly]="isPanVerified"
            [ngClass]="isPanVerified ? 'disabled' : ''" placeholder="PAN Number"
            oninput="this.value = this.value.toUpperCase()" (keydown)="notAllowSpace($event)" (input)="onInput($event)" />
          <div class="error-message" *ngIf="hasRequiredError('panNo')">&nbsp; <b>*Required</b></div>
          <div class="error-message" *ngIf="hasPatternError('panNo')">&nbsp; <b>*Invalid PAN No</b></div>
          <div class="error-message" *ngIf="bookingForm.get('panNo')?.value && bookingForm.get('panNo')?.hasError('invalidPanForIndividual')">
            &nbsp; <b>*Invalid PAN No for Individual</b>
          </div>
          <div class="error-message" *ngIf="bookingForm.get('panNo')?.value && bookingForm.get('panNo')?.hasError('invalidPanForCompany')">
            &nbsp; <b>*Invalid PAN No for Company</b>
          </div>
          
          
        </div>
       
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4"
          *ngIf="(isVasAvailable && (!isAdhaarVerified || !isPanVerified) && bookingForm.get('pan_type')?.value === 'Individual') || (isVasAvailable && !isPanVerified && bookingForm.get('pan_type')?.value === 'Company')">
          <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100 mt-4" data-toggle="tooltip"
            data-placement="top" title="Click here to Verify E-KYC" (click)="checkKYC()">Verify E-KYC</button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3 class="sub-title text-uppercase mb-3">Additional Details</h3>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Dealers near me          </label>
          <select class="form-select h-48" formControlName="dealer" (change)="setDivision();"
            [attr.disabled]="typeOfBooking ? '' : null"  [ngClass]="{
              'is-invalid': bookingForm.get('dealer').invalid && (bookingForm.get('dealer').dirty || bookingForm.get('dealer').touched || isSubmitForm)
            }">>
            <option value="" selected disabled>Select a dealer</option>
            <option *ngFor="let div of dealerList" [value]="div.division_id">
              {{ div.division_name }}
            </option>
          </select>
          <div
            *ngIf="bookingForm.get('dealer').invalid && (bookingForm.get('dealer').dirty || bookingForm.get('dealer').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('dealer').errors?.['required']">
              <b>   Dealer is required</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('dealer').errors?.['pattern']">
              <b>   Dealer is invalid</b>
            </div>
          </div>
          <div class="error-message" *ngIf="!finance && divData?.length == 0">
              <b>Dealer selection is required for financial approval</b>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="isDisabled">
          <label class="form-label mend" >Quantity</label>
          <input type="text" class="form-control  h-48" min="1" max="10"
            (keypress)="onlyNumberKey($event)" maxlength="2" autocomplete="new-password" numbersOnly
            formControlName="quantity" placeholder="Enter quantity" (keyup)="getQuantity()"
            (keydown)="notAllowSpace($event)" [attr.disabled]="isDisabled ?  null : 'disabled'"
            [ngClass]="{
              'is-invalid': bookingForm.get('quantity').invalid && (bookingForm.get('quantity').dirty || bookingForm.get('quantity').touched || isSubmitForm)
            }"/>
          <!-- [attr.disabled]="typeOfBooking ? '' : null" -->
          <div *ngIf="bookingForm.get('quantity').invalid &&
            (bookingForm.get('quantity').dirty || bookingForm.get('quantity').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('quantity').errors?.['required']">
              <b>   Quantity is required</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('quantity').errors?.['pattern']">
              <b>  Quantity is invalid</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('quantity').errors?.['min']">
              <b>   Min order qty is 1</b>
            </div>
            <div class="error-message" *ngIf="bookingForm.get('quantity').errors?.['max']">
              <b>   Max order qty is 10</b>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="dealerCode">
          <label class="form-label" >CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin
          </label>
          <input type="text" class="form-control  h-48" formControlName="dse" (keyup)="checkDSE($event)"
            placeholder="To be filled by Dealership" (keydown)="notAllowSpace($event)"
            [attr.disabled]="typeOfBooking && leadData.dse_username ? '' : null" />
          <div class="red-hl" *ngIf="dseLoaded && !dseMatch">CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin does not match</div>

        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4">
          <label class="form-label">Have Financier Approval</label>
          <div>
            <div class="form-check form-check-inline ">
              <input class="form-check-input" formControlName="haveFinancialApproval" (click)="finanacialApproval(true)"
                type="radio" name="haveFinancialApproval" id="Approvalyes" value="yes" checked>
              <label class="form-check-label" for="Approvalyes">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" formControlName="haveFinancialApproval"
                (click)="finanacialApproval(false)" type="radio" name="haveFinancialApproval" id="Approvalno"
                value="no">
              <label class="form-check-label" for="Approvalno">No</label>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4">
          <label class="form-label">Leasing Interest</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="leasingInterest" id="Leasingyes" value="yes"
                formControlName="leasingInterest" checked>
              <label class="form-check-label" for="Leasingyes">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="leasingInterest" id="Leasingno"
                formControlName="leasingInterest" value="no">
              <label class="form-check-label" for="Leasingno">No</label>
            </div>
          </div>
        </div>
        <div class=" col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label">Avail Annual Maintenance Contract </label>
          <div [ngClass]="this.isVasAvailable ? 'disabled' : ''">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="annulMaintenance" formControlName="annulMaintenance"
                id="Maintenanceyes" value="yes" checked>
              <label class="form-check-label" for="Maintenanceyes">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="annulMaintenance" formControlName="annulMaintenance"
                id="Maintenanceno" value="no">
              <label class="form-check-label" for="Maintenanceno">No</label>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="finance" >
          <label class="form-label">Finance</label>
          <select class="form-select h-48" formControlName="financeDrp" [disabled]="productOfferData">
            <option value="" selected disabled>Select a financier</option>
            <option *ngFor="let obj of fianceList" value="{{ obj.name }}">
              {{ obj.name }}
            </option>
          </select>

        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="!finance && divData?.length > 0 && !productOfferData">
          <div class="divisionData">
            {{ divData[0]?.division_name }}
            <br />
            {{ divData[0]?.first_name }} {{ divData[0]?.last_name }}
            <br />
            {{ divData[0]?.city }}, {{ divData[0]?.pincode }}
            <br />
            <img width="16px" class="basecolorgradient icons" [src]='environment1 + "assets/images/call-icon.svg"'
              alt="call-icon" *ngIf="divData[0]?.mobile_number" loading="lazy" />
            <a class="call" href="tel:{{ divData[0]?.mobile_number }}">
              {{ divData[0]?.mobile_number }}
            </a>
            <br />
          </div>
        </div>
        <ng-container *ngIf="divData?.length > 0">
          <div *ngIf="divData[0].payment_details?.length > 0" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
            <label class="form-label">Do you want to change booking amount?</label>
            <div>
              <div class="form-check form-check-inline cursor-pointer">
                <input class="form-check-input " type="radio" (change)="changeUsrBkgPerm($event)"
                  formControlName="bookingpermission" name="bookingpermission" id="bookingpermissionyes" value="yes">
                <label class="form-check-label" for="bookingpermissionyes">Yes</label>
              </div>
              <div class="form-check form-check-inline cursor-pointer">
                <input class="form-check-input " type="radio" (change)="changeUsrBkgPerm($event)"
                  formControlName="bookingpermission" name="bookingpermission" id="bookingpermissionno" value="no">
                <label class="form-check-label" for="bookingpermissionno">No</label>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="bookingForm.controls['bookingpermission'].value == 'yes'"
          class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Booking Amount</label>
          <input (keypress)="onlyNumberKey($event)" (keydown)="notAllowSpace($event)" (keyup)="changeBookingAmount()"
            type="text" formControlName="bookinguseramount" maxlength="6" class="form-control h-48"
            placeholder="Enter Booking Amount" />
          <div
            *ngIf="bookingForm.get('bookinguseramount').invalid && (bookingForm.get('bookinguseramount').dirty || bookingForm.get('bookinguseramount').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('bookinguseramount').errors?.['required']">
              *Required.
            </div>
            <div class="error-message" *ngIf="bookingForm.get('bookinguseramount').errors?.['min']">
              <b>Down payment should be greater than ₹ {{ productDetailList["down_payment"] }}</b>
            </div>
          </div>
          <div class="error-message" *ngIf="(!bookingForm.get('bookinguseramount').invalid) && totalAmount > 500000">
            &nbsp; <b>*Maximum booking amount limit is set to 5 Lacs.</b></div>
        </div>


        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 " *ngIf="showPaymentOption">
          <div class="form-check form-check-inline payment-selecttion-wrapper cursor-pointer">
            <input class="form-check-input cursor-pointer" type="radio" formControlName="paymentType" name="paymentType"
              id="RAZORPAY" value="razorpay" checked>
            <label class="form-check-label cursor-pointer" for="RAZORPAY">
              <img alt="razorpay" [src]='environment1 + "assets/images/razorpay.svg"' class="img-fluid"
                loading="lazy" />
            </label>
          </div>
          <div class="form-check form-check-inline cursor-pointer">
            <input class="form-check-input cursor-pointer" type="radio" formControlName="paymentType" name="paymentType"
              id="CCAVENUE" value="ccavenue">
            <label class="form-check-label cursor-pointer" for="CCAVENUE"><img alt="ccAvenue"
                [src]='environment1 + "assets/images/ccAvanue.svg"' class="img-fluid" loading="lazy" /></label>
          </div>
          <div
            *ngIf="bookingForm.get('paymentType').invalid && (bookingForm.get('paymentType').dirty || bookingForm.get('paymentType').touched || isSubmitForm)"
            class=" alert-danger">
            <div class="error-message" *ngIf="bookingForm.get('paymentType').errors?.['required']">
              *Required.
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 " *ngIf="showPaymentOption">
          <span style="color: green;">You can pay booking amount + down payment (if your financing is clear) to Tata Motors Authorized Dealer. You can pay a minimum of Rs. {{downpayment}} (as per vehicle category to a maximum of Rs. 5,00,000.)</span>
        </div>


        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="row">
            <div class="col-12 offset-sm-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
              <button type="button" data-bs-target="#VasRazorPayModal"
                class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" data-toggle="tooltip"
                data-placement="top" title="Click here for Confirm Booking" (click)="bookNow()" [disabled]="btndisable" >Proceed
              </button>
              <!-- [ngClass]="((!isAdhaarVerified || !isPanVerified )&& isVasAvailable)? 'disabled' : ''" -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<ng-template #vasRPay let-d="dismiss1">
  <div class="">

    <div class="modal-header">
      <h5 class="titletext">Payment Details</h5>
      <button type="button" (click)="close()" class="btn-close mb-10"></button>

    </div>
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-sm-1">
            <div class="card1">
              <ul id="progressbar" class="text-center">
                <li class="active step0"></li>
                <li class="active1 step0"></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-11">
            <div class="row">
              <div class="col-12 col-sm-12 margin-left-splitpayment">
                <span class="d-flex">
                  <h5 class="subtitle">Booking Amount</h5>
                  <span>
                    <h5 class="pricetxt">{{displayAmt | currency:'INR':'symbol':'4.0-0'}} </h5>
                  </span>
                </span>
                <div class="col-8">
                  <p class="detailtxt">This is the amount that you need to pay to book the vehicle.</p>
                  <button class="paynowbtn" data-toggle="tooltip" data-placement="top"
                    title="Click here to Proceed for Payment" (click)="callPaywithRazor()">Pay Now</button>
                </div>
              </div>
            </div>
            <div class="row disabled margintop">
              <div class="col-12 col-sm-12 margin-left-splitpayment">
                <span class="d-flex">
                  <h5 class="subtitle">VAS Booking Amount</h5>
                  <span>
                    <h5 class="pricetxtvas">{{ this.VasData?.VASBookingAmount | currency:'INR':'symbol':'4.0-0' }} </h5>
                  </span>
                </span>
                <div class="col-8">
                  <p class="detailtxt">This is the amount that you need to pay to for buying the VAS.</p>
                  <button class="paynowbtn" data-toggle="tooltip" data-placement="top"
                    title="Click here to Proceed for Payment">Pay Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<button type="button" hidden id="popuperror" class="btn btn-primary" data-bs-target="#popuperrorgeneral">
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade" id="popuperrorgeneral" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="border: none;">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
     <p style="font-size: 16px;text-align: center;">{{errormessage}}</p>
      </div>
      <div class="modal-footer justify-content-center" style="border: none;">
        <button type="button" class="btn border-primary"  [routerLink]="'/account/booking'" data-bs-dismiss="modal">Go to profile</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade " data-bs-backdrop="static" data-bs-keyboard="false" 
  id="cancelpopUp"
  tabindex="-1"
  aria-labelledby="cancelpopUp"
  aria-hidden="true" 
>
  <div class="modal-dialog modal-dialog-centered">
    <div
      class="modal-content modaldiv"
      style="background-color: #ffffff00; border: none"
    >
      <div
        class="modal-header"
        style="
          border-bottom: none !important;
          background: transparent;
          display: none;
        "
      >
        <button
          type="button"
          id="closeBtn1"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          aria-hidden="true"
        ></button>
      </div>
      <div
        class="modal-body text-secondary"
        style="height: 100% !important; margin-top: 0px; padding-top: 0px"
      >
        <div class="disconnect-websocket">
          <img
            _ngcontent-serverapp-c146=""
            style="text-align: center; align-items: center"
            alt="Loading-truck"
            width="200px"
            src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/Loading-truck.gif"
            class="ng-tns-c19-0"
          />
          <div class="cancel-btn" style="width: 100%">
             <div class="t-c">
               <span id="timer" *ngIf="timeLeft !== 0 && isTimer">link will be expired in {{ m ? m + " :" : "" }} {{ s ? s : "" }}</span> <a [ngClass]="{'d-none': (timeLeft !== 0 && isTimer)}"></a>
             </div>
            <button
              class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100 mt-2"
              (click)="closeWebSocketConnection()"
              data-toggle="tooltip"
              data-placement="top"
              title="Click here to Get Code"
            >
              Cancel
            </button>
          </div>
          <!-- <p style=" color: white;">text over here</p> -->
        </div>
      </div>
    </div>
  </div>
</div>